import styled from 'styled-components';

export const StyledFileSection = styled.div<{ $primaryColor: string }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
  max-width: 500px;

  .file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: ${props => props.$primaryColor || '#a03'};
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .file-info {
    flex: 1;
    min-width: 0;

    .file-label {
      font-size: 0.75rem;
      color: #6c757d;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 0.25rem;
    }

    .file-name {
      font-weight: 500;
      color: #212529;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        color: ${props => props.$primaryColor || '#a03'};
        text-decoration: underline;
      }
    }

    .file-placeholder {
      color: #adb5bd;
      font-style: italic;
    }
  }

  .file-actions {
    flex-shrink: 0;
  }
`